import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

const TURBO_STREAM_CONTENT_TYPE = "text/vnd.turbo-stream.html"

export default class extends Controller {
  static targets = ["subscribe", "unsubscribe"]
  static values = { saleId: Number, subscribed: Boolean }

  connect() {
    this.render()
  }

  disconnect() {
    this.request?.abort()
  }

  subscribedValueChanged() {
    this.render()
  }

  async toggle(event) {
    event.preventDefault()
    if (this.request) return

    const link = event.currentTarget
    const subscribed = event.params.subscribed
    this.request = new AbortController()
    link.setAttribute("aria-busy", "true")

    try {
      const response = await fetch(link.href, {
        method: subscribed ? "POST" : "DELETE",
        credentials: "same-origin",
        headers: {
          Accept: TURBO_STREAM_CONTENT_TYPE,
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        },
        signal: this.request.signal
      })

      if (response.redirected) {
        window.location.assign(response.url)
        return
      }
      if (!response.ok) throw new Error(`Sale alert request failed with status ${response.status}`)

      Turbo.renderStreamMessage(await response.text())
      this.synchronize(subscribed)
    } catch (error) {
      if (error.name !== "AbortError") console.error(error)
    } finally {
      this.request = null
      link.removeAttribute("aria-busy")
    }
  }

  render() {
    this.subscribeTargets.forEach(element => element.hidden = this.subscribedValue)
    this.unsubscribeTargets.forEach(element => element.hidden = !this.subscribedValue)
  }

  synchronize(subscribed) {
    const selector = `[data-controller~="website--sale-alert"][data-website--sale-alert-sale-id-value="${this.saleIdValue}"]`

    document.querySelectorAll(selector).forEach(element => {
      element.setAttribute("data-website--sale-alert-subscribed-value", subscribed)
    })
  }
}
